import { ISortOrder } from './../sort-toggle/sort-toggle.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseComponent } from '../base/base.component';
import { Account } from '../data/account';

@Component({
  selector: 'app-accounts',
  templateUrl: './accounts.component.html',
  styleUrls: ['./accounts.component.css']
})
export class AccountsComponent extends BaseComponent implements OnInit {
  searchValue: string = '';
  selectedSort: ISortOrder = { orderBy: "ID", ascending: false };

  ngOnInit() {
    this.allListItems = [];
      this.listItems$ = of(this.allListItems);
      this.searching = false;
  }

  getAccounts(sortOrder: ISortOrder): void {
    if (sortOrder)
        this.selectedSort = { orderBy: sortOrder.orderBy, ascending: sortOrder.ascending };
    else
        this.selectedSort = { orderBy: "AccountID", ascending: false }
    this.searching = true;
    this.dataService.getAccounts(this.searchValue, this.selectedSort.orderBy, this.selectedSort.ascending)
      .subscribe(accounts => {
        this.allListItems = accounts;
        this.listItems$ = of(accounts);
        this.searching = false;
      });
  }

  getRouterLink(account: Account) {
    return `/accounts/${account.ID}`;
  }

  navTo(account: Account) {
    this.goToRoute(account, `/accounts/${account.ID}`, null);
  }

  performSearch(term): Observable<any> {
    return this.dataService.getAccounts(term, this.selectedSort.orderBy, this.selectedSort.ascending);
  }
}
